module.exports = __webpack_public_path__ + "static/sopas-611f177ec844f09e893ba5dbf46443bc.jpg";